export default __webpack_public_path__ + "static/media/depositWithdrawalIcon1.dba8926b.webp";